import { observer } from "mobx-react-lite";
import ConsoleDemo from "../../../components/Home/Demo/ConsoleDemo";
import { AppCardProps } from "../../../components/common/AppCard/AppCard";
import RouterConstants from "../../../constants/RouterConstants";
import useSecureNavigate from "../../../hooks/useSecureNavigate";
import { useAppStore } from "../../../hooks/useStores";

const AdsGenerationDemo = () => {
	const navigate = useSecureNavigate();
	const { uiStore } = useAppStore();
	const cards: AppCardProps[] = [
		{
			card: "adsGenerator",
			onClick: () => {
				uiStore.showBackButton(RouterConstants.ADS_GENERATION.DEMO.fullPath);
				navigate(RouterConstants.ADS_GENERATION.DEMO.ADS_GENERATION.fullPath);
			},
		},
		// TODO: To add it later
		// {
		// 	card: "adsEditor",
		// 	onClick: () => {
		// 		uiStore.showBackButton(RouterConstants.ADS_GENERATION.DEMO.fullPath);
		// 		navigate(RouterConstants.ADS_GENERATION.DEMO.ADS_EDITOR.fullPath);
		// 	},
		// },
	];

	return <ConsoleDemo cards={cards} />;
};

export default observer(AdsGenerationDemo);
